package com.essntl.core.quickbooks.data

import kotlinx.serialization.Serializable

@Serializable
data class QuickbookSparseRequest(
    val SyncToken: String,
    val Id: String,
    val sparse: Boolean,
    val DueDate: String,
)